import { makeObservable } from 'mobx';

import { AssureBaseStore, IAssureStoreConstructorOptions } from './assure-base.store';
import { AccountConfigurationApiClient } from '../api/account-configuration-api-client';
import { ExternalRepositoryDto, ICreateExternalRepositorySettings, IUpdateExternalRepositorySettings, IParentAccountInfo } from '../dto/account-configuration.dto';

export class AccountConfigurationStore extends AssureBaseStore<AccountConfigurationApiClient, any> {

    public constructor(options: IAssureStoreConstructorOptions) {
        super(options);
        makeObservable(this);
    }

    protected get apiClient(): AccountConfigurationApiClient {
        return this.apiClientStore.apiClients.accountConfiguration;
    }

    public async getExternalVisibility(apiAccountId: number): Promise<boolean> {
        const response = await this.apiClient.getExternalVisibility(apiAccountId);
        return response.visible;
    }

    public async createExternalRepoSettings(apiAccountId: number, accountUuid: string, payload: ICreateExternalRepositorySettings): Promise<ExternalRepositoryDto> {
        const data = await this.apiClient.createExternalRepoSettings(apiAccountId, accountUuid, payload);
        return new ExternalRepositoryDto(data);
    }

    public async updateExternalRepoSettings(apiAccountId: number, accountUuid: string, payload: IUpdateExternalRepositorySettings): Promise<boolean> {
        const data = await this.apiClient.updateExternalRepoSettings(apiAccountId, accountUuid, payload);
        return data.result;
    }

    public async deleteExternalRepoSettings(apiAccountId: number, accountUuid: string): Promise<boolean> {
        const data = await this.apiClient.deleteExternalRepoSettings(apiAccountId, accountUuid);
        return data.result;
    }

    public async getExternalRepoSettings(apiAccountId: number, accountUuid: string, parentAccount?: IParentAccountInfo): Promise<ExternalRepositoryDto> {
       const data = await this.apiClient.getExternalRepoSettings(apiAccountId, accountUuid , parentAccount);
        return new ExternalRepositoryDto(data);
    }
}